// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3gSdH","top":"styles_top__2knJ6","left":"styles_left__1tQqm","description":"styles_description__wnbme"};